export enum HubMethods {
    RetrieveCaMeetingRequestContext = 'RetrieveCaMeetingRequestContext',
    OnCaMeetingRequestContext = 'onCaMeetingRequestContext',
    RetrieveCaResult = 'retrieveCaResult',
    OnCaResult = 'onCaResult',
}
